import { render, staticRenderFns } from "./ExtenalServicePreview.vue?vue&type=template&id=0b0b0a9a&scoped=true"
import script from "./ExtenalServicePreview.vue?vue&type=script&lang=ts"
export * from "./ExtenalServicePreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b0a9a",
  null
  
)

export default component.exports